var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.v4)?_c('iframe-v4-layout',{attrs:{"id":"v4-supplier-orders-table","url":_vm.url}}):_c('InsertionOrdersTable')}
var staticRenderFns = []

export { render, staticRenderFns }